/**
 * Drop-off email visual assets.
 *
 * Source: design handoff at /Users/lucabianchi/Downloads/stax-transactional-emails-download.jsx
 *
 * Hosted on the Stax Pages app (ass.staxlabs.org) — Vite copies
 * apps/web/public/email-assets/* into the deploy as-is. The originals
 * are decoded from the base64 inlines that lived here previously; if you
 * need to swap, decode the data URI, drop the file under that public/
 * dir, redeploy the web app, then update the URLs below.
 */

export const LOGO_SRC = "https://ass.staxlabs.org/email-assets/logo.jpg";

export const STARRY_BG = "https://ass.staxlabs.org/email-assets/starry-bg.jpg";

export const PERF_CHART_PLACEHOLDER = "https://ass.staxlabs.org/email-assets/perf-chart-placeholder.png";
